export default __webpack_public_path__ + "static/media/pantry1-afterB-480w.b624ad0c.avif";